import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../../hooks/useAuth'
import LoginForm from './_components/LoginForm'
import loginImage from '../../../assets/images/ic_login_img.png'
import { useTabAuth } from '@/hooks/useTabAuth'

export default function LoginPage(): React.JSX.Element {
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [countryCode, setCountryCode] = useState('1') // 默认美国
  const [phoneError, setPhoneError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const {
    isLoading,
    error,
    userLogin,
    navigateToMain,
    clearError
  } = useAuth()

  const tabAuth = useTabAuth()
  // 获取组织代码（从URL参数或状态中）
  const organizationCode = searchParams.get('org') || tabAuth.getOrganizationCode()

  // 检查是否有组织代码，没有则返回上一页
  useEffect(() => {
    if (!organizationCode) {
      navigate('/auth/organization')
      return
    }

  }, [organizationCode,])

  // 验证手机号
  const validatePhone = (phoneNumber: string): boolean => {
    setPhoneError('')
    if (!phoneNumber.trim()) {
      setPhoneError('请输入手机号')
      return false
    }
    if (!/^\d{4,20}$/.test(phoneNumber)) {
      setPhoneError('手机号格式不正确')
      return false
    }
    return true
  }

  // 验证密码
  const validatePassword = (pwd: string): boolean => {
    setPasswordError('')
    if (!pwd.trim()) {
      setPasswordError('请输入密码')
      return false
    }
    if (pwd.length < 6) {
      setPasswordError('密码至少6位')
      return false
    }
    return true
  }

  const handlePhoneChange = (value: string): void => {
    setPhone(value)
    if (phoneError) {
      validatePhone(value)
    }
    if (error) {
      clearError()
    }
  }

  const handlePasswordChange = (value: string): void => {
    setPassword(value)
    if (passwordError) {
      validatePassword(value)
    }
    if (error) {
      clearError()
    }
  }

  const handleCountryCodeChange = (newCountryCode: string): void => {
    setCountryCode(newCountryCode)
  }

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault()

    const isPhoneValid = validatePhone(phone)
    const isPasswordValid = validatePassword(password)

    if (!isPhoneValid || !isPasswordValid) {
      return
    }

    const success = await userLogin(phone, password, countryCode)
    if (success) {
      navigateToMain()
    }
  }


  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* 左侧插图区域 */}
      <div className="hidden lg:flex lg:flex-1 lg:flex-col lg:justify-center lg:items-center lg:px-10 xl:px-10">
        <div className="max-w-lg w-full">
          <img
            src={loginImage}
            alt="Welcome Illustration"
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* 右侧表单区域 */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8 xl:px-12 bg-white lg:max-w-md xl:max-w-lg">
        <div className="mx-auto w-full max-w-sm">
          <LoginForm
            phone={phone}
            password={password}
            countryCode={countryCode}
            onPhoneChange={handlePhoneChange}
            onPasswordChange={handlePasswordChange}
            onCountryCodeChange={handleCountryCodeChange}
            onSubmit={handleSubmit}
            isLoading={isLoading}
            error={error}
            phoneError={phoneError}
            passwordError={passwordError}
          />
        </div>

        {/* 底部语言选择 */}
        {/* <div className="absolute bottom-6 left-6">
          <button className="flex items-center text-sm text-gray-500 hover:text-gray-700">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            EN
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div> */}
      </div>
    </div>
  )
}
